export default __webpack_public_path__ + "static/media/dollar-tag.7b0ef9e0.svg";